import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, ActivationEnd, ActivatedRouteSnapshot  } from '@angular/router';
import { Location } from '@angular/common';
import moment from 'moment';
import { AppSettingService, AppService } from '../app.service';
import { UserInfoService } from '../user/user-info.service';
import { AccountAPIService, VisitHistoryAPIService } from '../user/account-api.service';
import { MapAPIService } from '../map/map-api.service';
import { MyJourneyAPIService } from '../myJourney/my-journey-api.service';

@Injectable({
	providedIn: 'root'
})
export class NavigationHistoryService {
	isAutoReroute: boolean = false;

	linkTypeNames = {
		1: { name: "Journey" },
		2: { name: "Map" },
		3: { name: "Learn More" },
		4: { name: "Search" }
	}

	ellipsisEntries: any[] = [];
	numEntries:number = 3;

	constructor(
		private userInfo: UserInfoService,
		private accountAPI: AccountAPIService,
		private visitAPI: VisitHistoryAPIService,
		private mapAPI: MapAPIService,
		private myJourneyAPI: MyJourneyAPIService,
		private route: ActivatedRoute,
		private router: Router,
		private location: Location		
	) {
		if (!this.userInfo.isAnonymous()) {
			this.visitAPI.getRecent(0, this.numEntries).subscribe(
				response => {
					if (response.length > 0) {
						//load up ellipsis entries from database for this session
						for (var i = 0; i < response.length; i++) {
							//sync with angular repeater
							let link = JSON.parse(response[i].EllipsisEntryJson);
							link.NewUI = response[i].NewUI;
							this.ellipsisEntries.push(link);
						}
						//sync with session storage
						sessionStorage["ellipsisEntries"] = JSON.stringify(this.ellipsisEntries);
					}
				},
				err => {
					console.log(err);
				}
			);
		}
		else {
			//populate this.ellipsisEntries if we have entries in session storage
			if (sessionStorage["ellipsisEntries"] !== undefined && sessionStorage["ellipsisEntries"] !== "") {
				let jsonSessionStorage = JSON.parse(sessionStorage["ellipsisEntries"]);
				for (let i = 0; i < jsonSessionStorage.length; i++) {
					if (jsonSessionStorage[i].NewUI == undefined) {
						jsonSessionStorage[i].NewUI = false;
					}
					this.ellipsisEntries.push(jsonSessionStorage[i]);
				}
			}
		}
	}

	clearEllipsisEntries() : void {
		let originalLength = this.ellipsisEntries.length;
		for (let i = 0; i < originalLength; i++) {
			this.ellipsisEntries.pop();
		}
		sessionStorage["ellipsisEntries"] = [];
	}

	pushEntry(currentEllipsisEntry: any) {
		currentEllipsisEntry.NewUI = true;
		let jsonSessionStorage: any = null;
		let tempEllipsisEntries: any = null;
		if (sessionStorage["ellipsisEntries"] !== "" && sessionStorage["ellipsisEntries"] !== undefined) {
			jsonSessionStorage = JSON.parse(sessionStorage["ellipsisEntries"])[0];
		}
		// are session and current same?
		if (JSON.stringify(currentEllipsisEntry) !== JSON.stringify(jsonSessionStorage)) {
			if (sessionStorage["ellipsisEntries"] == null || sessionStorage["ellipsisEntries"] == undefined || sessionStorage["ellipsisEntries"] === "" || sessionStorage["ellipsisEntries"].length === 0) {
				sessionStorage["ellipsisEntries"] = JSON.stringify([]);
				tempEllipsisEntries = JSON.parse(sessionStorage["ellipsisEntries"]);
			}
			else {
				tempEllipsisEntries = JSON.parse(sessionStorage["ellipsisEntries"]);
			}

			if (tempEllipsisEntries.length < this.numEntries) {
				tempEllipsisEntries.unshift(currentEllipsisEntry);
			}
			else {
				tempEllipsisEntries.pop();
				tempEllipsisEntries.unshift(currentEllipsisEntry);
			}

			sessionStorage["ellipsisEntries"] = JSON.stringify(tempEllipsisEntries);
			let parsedEllipsisEntries = JSON.parse(sessionStorage["ellipsisEntries"]);
			//this populates ellipsis popup (complete pop/push needed to retain reference to ng-repeat array)            
			for (var i = 0; i < parsedEllipsisEntries.length; i++) {
				this.ellipsisEntries.pop();
			}
			for (var i = 0; i < parsedEllipsisEntries.length; i++) {
				this.ellipsisEntries.push(parsedEllipsisEntries[i]);
			}

			//this adds the completed ellipsis entry info to the history database table 
			//(links are stored as stringified json so user can click into bread - crumb layers from view-all modal)
			if (!this.userInfo.isAnonymous()) {
				this.visitAPI.createHistoryEntry({NewUI:true, EllipsisEntryJson: JSON.stringify(currentEllipsisEntry) }).subscribe(
					response => {
						//console.log(response);
					},
					err => {
						console.log(err)
					}
				);
			}
		}
	}

	getMapObjectAncestory(objectId: string, currentEllipsisEntry: any, linkType: number) {
		this.mapAPI.getMapObjectAncestory(objectId).subscribe(
			data => {
				//populate ellipsisEntries.links
				if (linkType === 2) {
					for (var i = 0; i < data.length; i++) {
						currentEllipsisEntry.links.push({
							linkName: data[i].FactoryLongLabel,
							linkUrl: this.location.path() + "?ObjectID=" + data[i].object_id
						});
					}
				}
				if (currentEllipsisEntry.NewUI && linkType === 3) {
					for (var i = 0; i < data.length; i++) {
						currentEllipsisEntry.links.push({
							linkName: data[i].FactoryLongLabel,
							linkUrl: '/' + this.location.path().split('/')[1] + '/' + this.location.path().split('/')[2] + '/' + data[i].object_id
						});
					}
				} else if (!currentEllipsisEntry.NewUI && linkType === 3) {
					for (var i = 0; i < data.length; i++) {
						currentEllipsisEntry.links.push({
							linkName: data[i].FactoryLongLabel,
							linkUrl: '/' + this.location.path().split('/')[1] + '/' + data[i].object_id
						});
					}
				}
				currentEllipsisEntry.links.reverse();
				this.pushEntry(currentEllipsisEntry);
			},
			error => {
				console.log(error)
			}
		);
	}

	createEllipsisEntry(entry: any) : void {
		let currentEllipsisEntry = {
			NewUI: true,
			headerName: (this.linkTypeNames as any)[entry.LinkType].name,
			links: [] as any[],
			entryType: entry.LinkType
		};
		//if journey detail then get correctly named header (must be done here bc not stored in database)
		if (entry.LinkType === 1) {
			if (entry.AssociatedId !== undefined && entry.AssociatedId.length > 0) {
				let journeyUserId = this.route.snapshot.paramMap.get("journeyUserId");
				this.myJourneyAPI.getUserJourneyDetail(journeyUserId, null, null).subscribe(
					response => {
						currentEllipsisEntry.links.push({
							linkName: response.JourneyName,
							linkUrl: entry.LinkUrl
						});
						this.pushEntry(currentEllipsisEntry);
					},
					error => {
						console.log(error);
					}
				);
			} else {
				currentEllipsisEntry.links.push({
					linkName: "Your Saved Journeys",
					linkUrl: entry.LinkUrl
				})
				this.pushEntry(currentEllipsisEntry);
			}
		}
		//map type
		else if (entry.LinkType === 2) {
			if (entry.AssociatedId !== undefined && entry.AssociatedId.length > 0) {
				this.getMapObjectAncestory(entry.AssociatedId, currentEllipsisEntry, entry.LinkType);
			}
		}
		//learnmore type
		else if (entry.LinkType === 3) {
			if (entry.AssociatedId !== undefined && entry.AssociatedId.length > 0) {
				this.getMapObjectAncestory(entry.AssociatedId, currentEllipsisEntry, entry.LinkType);
			}
		}
		//search type
		else if (entry.LinkType === 4) {
			if (entry.SearchTerm !== undefined && entry.SearchTerm.length > 0) {
				currentEllipsisEntry.links.push({
					linkName: entry.SearchTerm,
					linkUrl: entry.LinkUrl
				})
				this.pushEntry(currentEllipsisEntry);
			}
		}
	}

	//this function receives link urls correctly figured out from location reception
	createHistoryEntry(linkType: any, linkUrl: any, searchTerm: any, associatedId: any) {
		var entry = { LinkType: linkType, LinkUrl: linkUrl, SearchTerm: searchTerm, AssociatedId: associatedId }
		//add entry to ellipsis
		this.createEllipsisEntry(entry);
	}

	
	//this function creates ellipsis-dropdown history entries for routes that have specified they should record history in module files.
	//this function is invoked via addBackUrl(...) when a page loads on route change event configured on app.component.ts.
	lastProcessedMapObjectId: string = "";
	checkLocation(): void {
		//currently we are following the same rules for ellipsis-history-dropdown item creation,
		//established by the desktop app's checkLocation function,
		//meaning the following types of pages are recorded in the ellipsis-history-dropdown:
		//***
		//--journeys
		//--map
		//--learnmore (all types)
		//***
		this.router.events.subscribe(
			(event: any) => {
				//***NOTE***:
				//		ActivationEnd runs many times due to the way angular handles routing
				//		(not because we are navigating here more than once due to logic bug)
				//	    So, we use compare incoming mapobjectid to lastProcessedMapObjectId to avoid firing the entry-creation-logic that was leading to multiple same API calls.
				if (event instanceof ActivationEnd) {
					let snapshot = (<ActivationEnd>event).snapshot;					
					if (snapshot) {
						let data = (<ActivatedRouteSnapshot>snapshot).data;						
						if (data && data["historyShouldRecord"]) {
							// record history of this route
							if (data["historyLinkType"] === 3) {
								//record this location into ellipsis dropdown history
								let objId = snapshot.paramMap.get("mapObjectId");
								
								if (objId !== null) {
									if (objId !== this.lastProcessedMapObjectId) {
										this.lastProcessedMapObjectId = objId;
										this.createHistoryEntry(3, this.location.path(), '', objId)
									}									
								}
							}
						}
					}
				}
			}
		);
	}
}


interface INavigationBack {
	NewUI: boolean,
	Path: string,
	TimeStamp: Date,
	ScrollTop: number
}

class NavigationBack implements INavigationBack {
	public NewUI: boolean = true;
	public Path: string = "";
	public TimeStamp: Date = new Date();
	public ScrollTop: number = 0;

	constructor(private url: string) {
		this.Path = url;
	}
}

@Injectable({
	providedIn: 'root'
})
export class NavigationBackService {
	ellipsisSearchTerm: any = null;
	mapEllipsisSearchTerm: any = null;
	storageName: string = "backStackUrls";

	constructor(
		private userInfo: UserInfoService,
		private historySrv: NavigationHistoryService,
		private location: Location,
		private router: Router,
		private appService: AppService
	) {
		let backs: INavigationBack[] = JSON.parse(sessionStorage.getItem(this.storageName));
		if (backs != null && backs.length > 0) {
			if (backs[0].TimeStamp == null) {
				this.clearBackUrls();
			}
			// remove old back history
			else {
				let len: number = backs.length;
				for (let i = len - 1; i >= 0; i--) {
					if (moment().isSameOrAfter(backs[i].TimeStamp, 'day') === false) {
						backs.pop();
					}
				}
			}
		}
		this.addBackUrl(this.location.path());
	}

	addBackUrl(url: string) {
		if (url != null) {
			let backs: INavigationBack[] = JSON.parse(sessionStorage.getItem(this.storageName));
			let previous: INavigationBack = (backs == null || backs == undefined) ? null : backs[backs.length - 1];
			if (backs == null) {
				backs = [];
			}
			if (previous == null || url !== previous.Path) {
				this.historySrv.checkLocation();
				backs.push(new NavigationBack(url));
				sessionStorage.setItem(this.storageName, JSON.stringify(backs));
			}
		}
	}

	clearBackUrls(): void {
		sessionStorage.removeItem(this.storageName);
	}

	updateCurrentEntryScrollTop(currentScrollTop: number = 0) {
		let backUrls = JSON.parse(sessionStorage.getItem(this.storageName));
		if (backUrls != null && backUrls.length > 0) {
			backUrls[backUrls.length - 1].ScrollTop = currentScrollTop;
			sessionStorage.setItem(this.storageName, JSON.stringify(backUrls));
		}
	}

	backButtonClick(): void {
		let backs: INavigationBack[] = JSON.parse(sessionStorage.getItem(this.storageName));
		let previous: INavigationBack = backs.length >= 2 ? backs[backs.length - 2] : null;
		backs.pop();
		sessionStorage.setItem(this.storageName, JSON.stringify(backs));
		if (previous) {
			if (previous.NewUI) {
				//when url paths are same, navigateByUrl does not "reload" component, so we need to do this:
				//(currently this can only handle one query parameter)
				let curRootPath = this.router.url.split('/')[1];
				let prevRootPath = previous.Path.split('/')[1];				

				let prevUrlQuerySplitItems = previous.Path.split('?');

				let prevUrlQueryParamName = '';
				let prevUrlQueryParamValue = '';

				let prevUrlBeforeQuery = '';

				if (prevUrlQuerySplitItems.length > 1) {
					prevUrlQueryParamName = prevUrlQuerySplitItems[1].split('=')[0];
					prevUrlQueryParamValue = prevUrlQuerySplitItems[1].split('=')[1];
					prevUrlBeforeQuery = prevUrlQuerySplitItems[0];
				}

				if (curRootPath === prevRootPath) {
					//we want to use redirectReload when previous and current root path are same
					if (prevUrlQueryParamName !== '' && prevUrlQueryParamValue !== '') {
						//when we have query param do this
						this.appService.redirectReload(prevUrlBeforeQuery, { queryParams: { [prevUrlQueryParamName]: prevUrlQueryParamValue } });
					} else {
						//when no query param (may have path variable here), do this
						this.appService.redirectReload(previous.Path);						
					}
				} else {
					//legacy default behavior of is NewUI
					this.router.navigateByUrl(previous.Path);
				}
			} else {
				//legacy behavior not NewUI
				window.location.href = AppSettingService.journeyUI + previous.Path;
			}
		} else {
			//legacy not previous
			this.clearBackUrls();

			if (this.userInfo.isAnonymous()) {				
				this.router.navigateByUrl("/Map");
			}
			else {
				this.router.navigateByUrl("/User/ProfileDashboard");
			}
		}
	}
}
